module.exports = __webpack_public_path__ + "img/ms-logo.789fd3be.svg";